import PropTypes from 'prop-types';

/**
 * SubjectInput Component
 *
 * A reusable component for email subject inputs that shows/hides the label
 * based on whether there's content in the field.
 *
 * @param {Object} props - Component props
 * @param {string} props.value - The current value of the subject field
 * @param {Function} props.setFieldValue - Function to update the field value (from Formik)
 * @param {string} props.name - The field name (used for both label and field name)
 * @param {Function} props.setDrawerTitle - Optional function to update a drawer title with the subject
 * @param {Object} props.style - Optional additional styles for the input
 */
const SubjectInput = ({ value = '', field, setFieldValue, name, setDrawerTitle, style = {} }) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    setFieldValue(field, newValue);

    // Only call setDrawerTitle if it's provided
    if (setDrawerTitle) {
      setDrawerTitle(newValue);
    }
  };

  return (
    <div className="email-form-header-field email-subject">
      <label className="space-between email-form--label">
        {!value.length && <strong>{name}</strong>}
        <input
          className="email-form--input-field"
          style={{ marginLeft: '5px', ...style }}
          value={value}
          onChange={handleChange}
          name="subject"
        />
      </label>
    </div>
  );
};

SubjectInput.propTypes = {
  value: PropTypes.string,
  field: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  setDrawerTitle: PropTypes.func,
  style: PropTypes.object,
};

export default SubjectInput;
